import React, { Component } from "react";
import moment from "moment";
import {
	Button,
	Card,
	Col,
	Input,
	DatePicker,
	Row,
	Upload,
	message,
} from "antd";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { inject } from "mobx-react";
import claimTypes from "../../../../../configs/claim-types";
import { CUSTOMER_CLAIM } from "../../../../../configs/api-paths";

@inject("context")
class CustomerClaim extends Component {
	state = {
		claimDocumentIds: [],
		lossDate: "",
		type: "",
		description: "",
		fileDescription: "",
	};

	render() {
		const { quote } = this.props.location;
		const { TextArea } = Input;
		const BASE_API_URL = process.env.INSURFORCE_BASE_API_URL;

		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 20,
						paddingRight: 20,
					},
				}}
			>
				<Row>
					<Col xs={24} className="portal-card">
						<Card title={<h1>Make a Claim</h1>}>
							<Row>
								<Col xs={10}>
									<p>Policy number</p>
								</Col>
								<Col xs={14}>
									<p>{quote.policyNumber}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Product</p>
								</Col>
								<Col xs={14}>
									<p>{quote.product.name}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Insurer</p>
								</Col>
								<Col xs={14}>
									<p>{quote.product.insurer.name}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Property Address</p>
								</Col>
								<Col xs={14}>
									<p>
										{quote.address1}
										<br />
										{quote.address2}	
										<br />
										{quote.city}
										<br />
										{quote.postcode}
									</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Date and time the incident occurred</p>
								</Col>
								<Col xs={14}>
									<DatePicker format = "DD-MM-YYYY" 
										showTime={{
											format: "HH:mm",
											defaultValue: moment("08:00", "HH:mm"),
										}}
										onChange={(date) => this.onChangeLossDate(date)}
									/>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Type of Loss</p>
								</Col>
								<Col xs={14}>
									<select
										onChange={this.onChangeSelected}
										defaultValue={"DEFAULT"}
									>
										<option value="DEFAULT" disabled>
											Choose type of loss
										</option>
										{Object.keys(claimTypes).map((claimType, index) => {
											return (
												<option key={index} value={claimType}>
													{claimType}
												</option>
											);
										})}
									</select>
								</Col>
							</Row>
							<Row>
								<p>
									State fully the cause of the loss or damage and give full
									details of how it occurred, please provide as much detail as
									possible
								</p>
							</Row>
							<Row>
								<TextArea
									rows={4}
									onChange={this.handleDescriptionInputChange}
								/>
							</Row>
							<Row style={{ marginTop: 10 }}>
								<Col xs={10}>
									<p>File description (optional)</p>
								</Col>
								<Col xs={14}>
									<TextArea
										rows={2}
										onChange={this.handleFileDescriptionInputChange}
									/>
								</Col>
							</Row>
							<Row style={{ marginTop: 10 }}>
								<Col xs={18}>
									<p>
										Attach any documentary evidence here (images, pdfs and
										documents only)
									</p>
								</Col>
								<Col xs={6}>
									<Upload
										action={BASE_API_URL + CUSTOMER_CLAIM}
										data={{
											policyNumber: quote.policyNumber,
											description: this.state.fileDescription,
										}}
										onChange={this.handleUploadChange}
										onRemove={this.handleUploadOnRemove}
									>
										<Button
											style={{
												background: "#0AE320",
												borderColor: "#0AE320",
												fontSize: "13px",
												padding: "0 4px",
											}}
										>
											Upload Files
										</Button>
									</Upload>
								</Col>
							</Row>
							<Row>
								<Col xs={18} />
								<Col xs={6}>
									<Button onClick={this.handleSubmitButtonClick}>Submit</Button>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleUploadOnRemove = (file) => {
		const { claimDocumentService } = this.props.context;
		claimDocumentService.deleteClaimDocument(file.response);
	};

	handleFileDescriptionInputChange = (e) => {
		this.setState({
			fileDescription: e.target.value,
		});
	};

	handleDescriptionInputChange = (e) => {
		this.setState({
			description: e.target.value,
		});
	};

	handleUploadChange = (info) => {
		let { file } = info;
		let { claimDocumentIds } = this.state;

		if (file.response && file.status === "done") {
			message.success(`${info.file.name} file uploaded successfully`, 5);
			if (claimDocumentIds.indexOf(file.response) === -1) {
				// prevent duplicates
				claimDocumentIds.push(file.response);
				this.setState({ claimDocumentIds: claimDocumentIds });
			}
		} else if (file.status === "error") {
			message.error(
				`${info.file.name} file upload failed. Error: ${info.file.response.message}`,
				10
			);
		}
	};

	handleSubmitButtonClick = async () => {
		const { claimsService, customerPortalService } = this.props.context;
		const { quote, token } = this.props.location;
		const { type, lossDate, description } = this.state;
		if (type === "") {
			message.error(`Please define type of claim before submitting`);
			return;
		} else if (lossDate === "") {
			message.error(`Please define loss date before submitting`);
			return;
		}
		const claim = {
			lossDate: lossDate,
			type: type,
			description: description,
			updatedBy: customerPortalService.customerEmail,
			quote: quote,
		};
		const fnol = {
			claim: claim,
			claimDocumentIds: this.state.claimDocumentIds,
		};
		await claimsService.fnol(fnol);
		this.props.history.push(`/portal/${token}`);
	};

	onChangeLossDate(dateTime) {
		this.setState({
			lossDate: dateTime,
		});
	}

	onChangeSelected = async (e) => {
		this.setState({
			type: e.target.value,
		});
	};
}

export default CustomerClaim;
